import type { WorkspaceTurnContext } from '@/workspace/types';

/** Stop/error may close native SSE before its terminal workspace event arrives. */
export function finishPreviewContext(context: WorkspaceTurnContext) {
  return context.intent.mode === 'skill-preview'
    ? { ...context, intent: { ...context.intent, mode: 'skill-author' as const } }
    : context;
}
